<template>
  <div class="page-temp">
    <div class="temp-main">
      <img src="../../assets/image/temp-bg.png" alt="建设中" />
      <p>很抱歉，当前页面内容正在建设中</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'publicTemp'
}
</script>
<style lang='scss' scoped>
.page-temp {
  padding: 36px 0 50px;
  .temp-main {
    width: 1200px;
    height: 500px;
    margin: 0 auto;
    padding: 138px 0 108px 0;
    background: #fff;
    img {
      width: 304px;
      height: 304px;
      display: block;
      margin: 0 auto 30px;
    }
    p {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #999999;
      text-align: center;
    }
  }
}
</style>
